import type { SelectProps } from 'antd';
import { Select, Spin } from 'antd';
import React, { useEffect, useState } from 'react';

import { CountryResponseType, CountryType } from '../../../types';

interface CountrySelectProps {
    value?: string | null;
    onChange?: (value: string | undefined) => void;
    placeholder?: string;
    style?: React.CSSProperties;
    className?: string;
}

const { Option } = Select;

const CountrySelect: React.FC<CountrySelectProps> = React.forwardRef<any, CountrySelectProps>(
    ({ value, onChange, placeholder = 'Select country', style, className, ...restProps }, _ref) => {
        const [countries, setCountries] = useState<CountryType[]>([]);
        const [loading, setLoading] = useState(true);

        useEffect(() => {
            fetchCountries();
        }, []);

        const fetchCountries = async () => {
            try {
                const response = await fetch('https://restcountries.com/v3.1/all?fields=name,cca2');
                const data: CountryResponseType[] = await response.json();

                const formattedCountries: CountryType[] = data
                    .map((country) => ({
                        value: country.cca2.toLowerCase(),
                        label: country.name.common,
                    }))
                    .sort((a, b) => a.label.localeCompare(b.label));

                setCountries(formattedCountries);
            } catch (error) {
                console.error('Error fetching countries:', error);
            } finally {
                setLoading(false);
            }
        };

        const filterOption: SelectProps['filterOption'] = (input, option) =>
            (typeof option?.label === 'string' ? option.label : '').toLowerCase().includes(input.toLowerCase());

        return (
            <Select
                showSearch
                value={value}
                placeholder={placeholder}
                loading={loading}
                onChange={onChange}
                filterOption={filterOption}
                className={className}
                notFoundContent={loading ? <Spin size="small" /> : null}
                optionLabelProp="label"
                style={style}
                {...restProps}
            >
                {countries.map((country) => (
                    <Option key={country.value} value={country.value} label={country.label}>
                        {country.label}
                    </Option>
                ))}
            </Select>
        );
    },
);

export default CountrySelect;
